import React from 'react';
import Download from '../assets/img/download-red20.png';
import PDF1 from '../assets/downloads/Automation-HSC Transduction - Prodigy vs Manual.pdf';
import PDF2 from '../assets/downloads/CCS Information Brochure.pdf';
import PDF3 from '../assets/downloads/CliniMACS Hematology Flyer.pdf';
import PDF4 from '../assets/downloads/CliniMACS ProdigyR HSC Engineering System.pdf';
import PDF5 from '../assets/downloads/CliniMACS_Prodigy_ACC_MSC_expansion_Appsheet.pdf';
import PDF6 from '../assets/downloads/CliniMACS_Prodigy_System_brochure.pdf';
import PDF7 from '../assets/downloads/CliniMACS_Prodigy_TCT_Transduction_Process_Appsheet.pdf';
import PDF8 from '../assets/downloads/Cutting-edge_HSC_Research_flyer.pdf';
// import PDF9 from '../assets/downloads/Depletion of CD3 or enrichment of CD56+ cells - Prodigy.pdf';
import PDF10 from '../assets/downloads/Gene-engineered Haematopoeric stem cells.pdf';
import PDF11 from '../assets/downloads/MACS GMP Product Flyer.pdf';
import PDF12 from '../assets/downloads/Manufacturing NK cell products for clinical research.pdf';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';

function Downloads() {
    return (
        <>
            <Header1 />
                <section className='blog-wrapper news-wrapper section-padding'>
                    <div className='container'>
                        <div className='row'>
                            <div className="col-md-12">
                                <div className="news-content"  >
                                <div className="download-brochure w-100">
                                        <div className="brochure-heading" style={{backgroundColor:"#caebfd"}}>
                                            <span style={{fontSize: "24px", color:"#240661"}}><b>Download Brochure</b></span>
                                        </div>
                                        <div className="brochure-body">
                                            <a href={PDF1} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}>
                                                <img src={Download} className="download-img" />Automation-HSC Transduction - Prodigy vs Manual
                                            </a>
                                        </div>
                                        <div className="brochure-body">
                                            <a href={PDF2} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}  >
                                                <img src={Download} className="download-img"  />CCS Information Brochure
                                            </a>
                                        </div>
                                        <div className="brochure-body">
                                            <a href={PDF3} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}   >
                                                <img src={Download} className="download-img"  />CliniMACS Hematology Flyer
                                            </a>
                                        </div>
                                        <div className="brochure-body">
                                            <a href={PDF4} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}  >
                                                <img src={Download} className="download-img"  />CliniMACS ProdigyR HSC Engineering System
                                            </a>
                                        </div>
                                        <div className="brochure-body">
                                            <a href={PDF5} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}    >
                                                <img src={Download} className="download-img"  />CliniMACS_Prodigy_ACC_MSC_expansion_Appsheet
                                            </a>
                                        </div>
                                        <div className="brochure-body">
                                            <a href={PDF6} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}    >
                                                <img src={Download} className="download-img"  />CliniMACS_Prodigy_System_brochure
                                            </a>
                                        </div>
                                        <div className="brochure-body">
                                            <a href={PDF7} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}    >
                                                <img src={Download} className="download-img"  />CliniMACS_Prodigy_TCT_Transduction_Process_Appsheet
                                            </a>
                                        </div>
                                        <div className="brochure-body">
                                            <a href={PDF8} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}    >
                                                <img src={Download} className="download-img"  />CCutting-edge_HSC_Research_flyer
                                            </a>
                                        </div>
                                        {/* <div className="brochure-body">
                                            <a href={PDF9} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}    >
                                                <img src={Download} className="download-img"  />Depletion of CD3 or enrichment of CD56+ cells - Prodigy
                                            </a>
                                        </div> */}
                                        <div className="brochure-body">
                                            <a href={PDF10} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}    >
                                                <img src={Download} className="download-img"  />Gene-engineered Haematopoeric stem cells
                                            </a>
                                        </div>
                                        <div className="brochure-body">
                                            <a href={PDF11} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}    >
                                                <img src={Download} className="download-img"  />MACS GMP Product Flyer
                                            </a>
                                        </div>
                                        <div className="brochure-body">
                                            <a href={PDF12} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}    >
                                                <img src={Download} className="download-img"  />Manufacturing NK cell products for clinical research
                                            </a>
                                        </div>
                                        <div className="brochure-footer"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            <Footer1 />
        </>
    );
}

export default Downloads;
